import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { catchError, map, Observable, of } from 'rxjs';

import { ZipCodeVerificationRestService } from '../../services/zip-code-verification-rest.service';
import { ZipCodeStatus } from '../../shared/models/prequal.types';

@Injectable({ providedIn: 'root' })
export class ResidenceZipCodeAsyncValidator implements AsyncValidator {
  constructor(
    private readonly zipCodeVerificationRestService: ZipCodeVerificationRestService
  ) {}

  validate({
    value: zipCode,
  }: AbstractControl): Observable<ValidationErrors | null> {
    if (!zipCode) {
      return of(null);
    }
    return this.zipCodeVerificationRestService.verifyZipCode(zipCode).pipe(
      map((response) => {
        const verification = response?.zipCodeVerification;
        if (!verification) {
          return { zipCodeError: true };
        }
        const { zipCodeIsValid, zipCodeStatus } = verification;
        switch (true) {
          case zipCodeIsValid:
            return null;
          case zipCodeStatus === ZipCodeStatus.InvalidTerritoryError:
            return { territoryError: true };
          default:
            return { zipCodeError: true };
        }
      }),
      catchError(() => of(null))
    );
  }
}
